import { Text } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../../i18n/i18n';
import { CurrentMarkupInfoProps } from './types';

export const CurrentMarkupInfo = ({ activeMarkup, disabled, label }: CurrentMarkupInfoProps) => {
  const { t } = useTypedTranslation();
  return (
    <>
      <Text color="black70" fontWeight="light" size="small">
        {label ? label : t('common.validFromDate', { date: activeMarkup.startDate })}
      </Text>
      <Text marginBottom={20} color={disabled ? 'black20' : undefined} size="medium">
        {activeMarkup.fokText || `${activeMarkup.fokId} (${t('section.employmentDetails.fokTextMissing')})`}
      </Text>
    </>
  );
};
